/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.8.0-nightly.2026.11.3",
    versionName: "0.8.0-nightly.2026.11.3",
    versionChannel: "nightly",
    buildDate: "2026-11-03T00:14:07.310Z",
    commitHash: "489fc3a99aabb4a17e0dc1e0afc729f83b03cd8f",
};
